import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  TaskRecordCreateDialogData, TaskRecordCreateDialogMode,
  TaskRecordCreateDialogResult,
  TaskRecordCreateFormComponent
} from "./task-record-create-form/task-record-create-form.component";

@Component({
  selector: 'app-task-record-create-material-dialog',
  templateUrl: './task-record-create-material-dialog.component.html',
  styleUrls: ['./task-record-create-material-dialog.component.scss']
})
export class TaskRecordCreateMaterialDialogComponent {

  @ViewChild('formComponent') formComponent!: TaskRecordCreateFormComponent;

  creationInProgress: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TaskRecordCreateMaterialDialogComponent, TaskRecordCreateDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: TaskRecordCreateDialogData
  ) {}

  public static openDialog(
    dialog: MatDialog,
    data: TaskRecordCreateDialogData,
    resultCallback: (result?: TaskRecordCreateDialogResult) => void
  ) {
    const dialogRef = dialog.open(TaskRecordCreateMaterialDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: TaskRecordCreateDialogResult) => {
      resultCallback(result);
    });
  }

  closeDialog(success: boolean, request?: any) {
    this.dialogRef.close({ success: success, request: request });
  }

  onFormFinished(result: TaskRecordCreateDialogResult) {
    this.dialogRef.close(result);
  }

  getTitleKey() {
    if (this.data.mode === TaskRecordCreateDialogMode.REQUEST_ONLY) {
      return 'TASK_RECORD_CREATE_REQUEST_ONLY_HEADER';
    }
    return 'EMPTY_DASHBOARD_CREATE_TASK';
  }

  getSubmitButtonKey() {
    if (this.data.mode === TaskRecordCreateDialogMode.REQUEST_ONLY) {
      return 'COMMON_BUTTON_SAVE';
    }
    return 'EMPTY_DASHBOARD_CREATE_TASK';
  }
}
